/*
 * Free Shipping Tracker - Web Components
 * Integrates with Dawn's pub/sub system (pubsub.js / constants.js)
 */

/* === Toast Popup Component === */
if (!customElements.get('free-shipping-popup')) {
  customElements.define(
    'free-shipping-popup',
    class FreeShippingPopup extends HTMLElement {
      constructor() {
        super();
        this.toast = this.querySelector('.fst-toast');
        this.closeBtn = this.querySelector('.fst-toast__close');
        this.autoDismissSeconds = parseInt(this.dataset.autoDismiss) || 5;
        this.popupEnabled = this.dataset.popupEnabled === 'true';
        this.sectionId = this.dataset.sectionId;
        this.dismissTimer = null;
      }

      cartUpdateUnsubscriber = undefined;

      connectedCallback() {
        if (!this.popupEnabled) return;

        this.closeBtn?.addEventListener('click', () => this.hide());

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-form') {
            this.onCartUpdate();
          }
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      onCartUpdate() {
        fetch(`${routes.cart_url}?section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newContent = doc.querySelector('.fst-toast__content');
            const currentContent = this.querySelector('.fst-toast__content');
            if (newContent && currentContent) {
              currentContent.innerHTML = newContent.innerHTML;
            }
            this.show();
          })
          .catch(console.error);
      }

      show() {
        clearTimeout(this.dismissTimer);
        this.style.display = '';
        // Force reflow for CSS transition
        this.offsetHeight;
        this.classList.add('fst-popup--active');

        this.dismissTimer = setTimeout(() => {
          this.hide();
        }, this.autoDismissSeconds * 1000);
      }

      hide() {
        clearTimeout(this.dismissTimer);
        this.classList.remove('fst-popup--active');
        this.addEventListener(
          'transitionend',
          () => {
            if (!this.classList.contains('fst-popup--active')) {
              this.style.display = 'none';
            }
          },
          { once: true }
        );
      }
    }
  );
}

/* === Cart Page Inline Tracker Component === */
if (!customElements.get('free-shipping-cart')) {
  customElements.define(
    'free-shipping-cart',
    class FreeShippingCart extends HTMLElement {
      constructor() {
        super();
      }

      cartUpdateUnsubscriber = undefined;

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          this.onCartUpdate();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      onCartUpdate() {
        const sectionId = this.closest('[data-section-id]')?.dataset.sectionId;
        if (!sectionId) return;

        fetch(`${routes.cart_url}?section_id=${sectionId}`)
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newContents = doc.querySelector('.fst-cart.js-contents');
            const currentContents = this.querySelector('.fst-cart.js-contents');
            if (newContents && currentContents) {
              currentContents.innerHTML = newContents.innerHTML;
            }
          })
          .catch(console.error);
      }
    }
  );
}
